import { decisioningStudioTiers } from "./constants";

/**
 * Only GO agents are editable in the dashboard. Every other tier (PRO, the deprecated
 * `ofl_legacy`, anything conman adds later) is managed by the BrazeAI Decisioning Studio
 * team and is read-only. A missing tier stays editable: the legacy sync-based digest
 * carries none, and a failed or 404 details query leaves it undefined.
 */
export const isReadOnlyUseCase = (tier?: string | null): boolean =>
  tier !== undefined && tier !== null && tier !== decisioningStudioTiers.GO;
